import React, { useEffect, useState } from "react";
import "./Cart_Products_card.css";
import { Table, Modal, Button } from "react-bootstrap";
import Increment_decrement_btn_holder from "../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import Increment_decrement_btn_holder_add from "../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder_add";
import { deleteAllCart, getAllCart } from "../../../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { encodeId, variant_type } from "../../../utils/common";
import Green_round_btn from "../../common-components/common_btn/green_round_btn/Green_round_btn";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import Green_Outline_Btn from "../../common-components/common_btn/green_outline_btn/Green_Outline_Btn";
import Orange_Btn from "../../common-components/common_btn/orange_btn/Orange_Btn";
import { appSetup } from "../../../features/master/masterSlice";

function Cart_Products_card({ data, instock, setInstock }) {
  const isSignin = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteData, setDeleteData] = useState({
    id: null,
    product_id: null,
    variant_id: null,
  });

  const openDeleteModal = (id, product_id, variant_id) => {
    setDeleteData({
      id,
      product_id,
      variant_id,
    });

    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    await deleteCart(
      deleteData.id,
      deleteData.product_id,
      deleteData.variant_id,
    );

    setShowDeleteModal(false);
  };

  const deleteCart = async (id, product_id, varient_id) => {
    const res = await dispatch(
      deleteAllCart({
        id,
        isSignin,
        product_id,
        varient_id,
      }),
    );

    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllCart(isSignin));
    } else if (res.meta?.requestStatus === "rejected") {
      console.log("Error:", res.payload || "Not In Cart");
    }
  };
  const navigate = useNavigate();

  const app_setup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  const getStock = (item) => {
    if (item?.Triple_Variant) {
      return Number(item?.Triple_Variant?.stock || 0);
    }

    if (item?.Double_Variant) {
      return Number(item?.Double_Variant?.stock || 0);
    }

    if (item?.Product_Variant) {
      return Number(
        item?.Product_Variant?.stock ||
          item?.Product_Variant?.general_stock ||
          0,
      );
    }

    return 0;
  };

  useEffect(() => {
    if (data?.data?.length > 0) {
      const anyOutOfStock = data.data.some((val) => {
        const stock = getStock(val);
        const quantity = Number(val?.quantity || 0);

        return quantity > stock;
      });

      setInstock(anyOutOfStock);
    } else {
      setInstock(false);
    }
  }, [data]);

  const currentCurrency = useSelector((state) => state.master.currentCurrency);
  // const rate = Number(currentCurrency?.rate) || 1;
  const symbol = currentCurrency?.symbol || "$";

  const getVariantData = (item) => {
    if (item?.Triple_Variant) {
      return item.Triple_Variant;
    }

    if (item?.Double_Variant) {
      return item.Double_Variant;
    }

    if (item?.Product_Variant) {
      return item.Product_Variant;
    }

    return {};
  };

  const getOfferDetails = () => {
    const offerDetails = {};

    if (!Array.isArray(data?.data) || data.data.length === 0) {
      return offerDetails;
    }

    const totalQuantity = data.data.reduce(
      (sum, item) => sum + Number(item?.quantity || 0),
      0,
    );

    const buyOneGetOneEnabled =
      app_setup?.buy_one_status === true ||
      app_setup?.buy_one_status === 1 ||
      app_setup?.buy_one_status === "1";

    /*
     * BUY 1 GET 1
     *
     * Apply ONLY when:
     * 1. Buy 1 Get 1 status is enabled
     * 2. Total cart quantity is 2 or more
     */
    if (buyOneGetOneEnabled && totalQuantity >= 2) {
      const buyOneProducts = [];

      data.data.forEach((item, index) => {
        const price = Number(getVariantData(item)?.price || 0);
        const quantity = Number(item?.quantity || 0);

        for (let i = 0; i < quantity; i++) {
          buyOneProducts.push({
            index,
            price,
          });
        }
      });

      // Same sorting as backend
      buyOneProducts.sort((a, b) => b.price - a.price);

      const freeQuantityByProduct = {};
      const freeAmountByProduct = {};
      const oddDiscountByProduct = {};

      const totalProducts = buyOneProducts.length;
      const freeProductCount = Math.floor(totalProducts / 2);

      /*
       * SAME LOGIC AS BACKEND
       *
       * EVEN:
       * Highest half = PAID
       * Lowest half = FREE
       *
       * ODD:
       * Highest products = PAID
       * Middle half = FREE
       * Lowest product = ODD DISCOUNT
       */

      if (totalProducts % 2 === 0) {
        // EVEN QUANTITY
        const freeStartIndex = totalProducts - freeProductCount;

        for (let i = freeStartIndex; i < totalProducts; i++) {
          const freeProduct = buyOneProducts[i];

          freeQuantityByProduct[freeProduct.index] =
            (freeQuantityByProduct[freeProduct.index] || 0) + 1;

          freeAmountByProduct[freeProduct.index] =
            (freeAmountByProduct[freeProduct.index] || 0) +
            Number(freeProduct.price || 0);
        }
      } else {
        // ODD QUANTITY

        const freeStartIndex = totalProducts - freeProductCount - 1;

        const freeEndIndex = totalProducts - 1;

        // FREE products
        for (let i = freeStartIndex; i < freeEndIndex; i++) {
          const freeProduct = buyOneProducts[i];

          freeQuantityByProduct[freeProduct.index] =
            (freeQuantityByProduct[freeProduct.index] || 0) + 1;

          freeAmountByProduct[freeProduct.index] =
            (freeAmountByProduct[freeProduct.index] || 0) +
            Number(freeProduct.price || 0);
        }

        // ODD PRODUCT DISCOUNT
        const oddProduct = buyOneProducts[totalProducts - 1];

        let oddProductDiscount = Number(app_setup?.odd_product_discount || 0);

        oddProductDiscount = Math.max(0, Math.min(100, oddProductDiscount));

        if (oddProductDiscount > 0) {
          const oddDiscountAmount =
            (Number(oddProduct.price || 0) * oddProductDiscount) / 100;

          oddDiscountByProduct[oddProduct.index] = {
            percentage: oddProductDiscount,
            amount: oddDiscountAmount,
          };
        }
      }

      data.data.forEach((item, index) => {
        const freeQuantity = freeQuantityByProduct[index] || 0;
        const freeAmount = freeAmountByProduct[index] || 0;
        const oddDiscount = oddDiscountByProduct[index];

        if (freeQuantity > 0 || oddDiscount) {
          offerDetails[index] = {
            type: "buy_one_get_one",

            /*
             * Keep this type so existing JSX continues working.
             * Actual badge text is determined below.
             */
            discountType:
              freeQuantity > 0 && oddDiscount
                ? "Buy 1 Get 1"
                : freeQuantity > 0
                ? "Buy 1 Get 1"
                : "Odd Product Discount",

            freeQuantity,
            freeAmount,

            oddDiscountPercentage: oddDiscount?.percentage || 0,

            oddDiscountAmount: oddDiscount?.amount || 0,

            totalDiscount: freeAmount + Number(oddDiscount?.amount || 0),
          };
        }
      });

      return offerDetails;
    }

    const globalDiscount = Number(app_setup?.global_discount || 0);

    data.data.forEach((item, index) => {
      const price = Number(getVariantData(item)?.price || 0);

      const quantity = Number(item?.quantity || 0);

      const lineTotal = price * quantity;

      let discountPercentage = 0;
      let discountType = "";

      /*
       * PRODUCT DISCOUNT
       */
      const productDiscount = Number(item?.Product?.prod_discount);

      if (
        item?.Product?.prod_discount !== null &&
        item?.Product?.prod_discount !== undefined &&
        item?.Product?.prod_discount !== "" &&
        !isNaN(productDiscount) &&
        productDiscount > 0
      ) {
        discountPercentage = productDiscount;
        discountType = "Product Discount";
      } else {
        /*
         * CATEGORY DISCOUNT
         */
        const categoryDiscount = Number(
          item?.Product?.p_category?.cat_discount,
        );

        if (
          item?.Product?.p_category?.cat_discount !== null &&
          item?.Product?.p_category?.cat_discount !== undefined &&
          item?.Product?.p_category?.cat_discount !== "" &&
          !isNaN(categoryDiscount) &&
          categoryDiscount > 0
        ) {
          discountPercentage = categoryDiscount;
          discountType = "Category Discount";
        } else if (!isNaN(globalDiscount) && globalDiscount > 0) {
          
          discountPercentage = globalDiscount;
          discountType = "Flat Discount";
        }
      }

      discountPercentage = Math.max(0, Math.min(100, discountPercentage));

      const discountAmount = (lineTotal * discountPercentage) / 100;

      if (discountPercentage > 0 && discountAmount > 0) {
        offerDetails[index] = {
          type: "normal_discount",

          discountType,
          percentage: discountPercentage,

          amount: discountAmount,
          totalDiscount: discountAmount,

          freeQuantity: 0,
          freeAmount: 0,
        };
      }
    });

    return offerDetails;
  };

  const offerDetails = getOfferDetails();

  return (
    <>
      <section className="Cart_Products_card">
        <div className="container-fluid">
          <div className="desktop_viw_table_holder">
            <div className="table-responsive">
              <Table>
                <thead>
                  <tr>
                    <th>Product</th>
                    <th className="text-center">Quantity</th>
                    <th className="text-end">
                      <b>Total</b>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.data.map((val) => {
                    const quantity = Number(val?.quantity);

                    const variantData = getVariantData(val);

                    const currentStock = getStock(val);

                    const isOutOfStock = currentStock <= 0;

                    const disableIncrease = quantity >= currentStock;

                    const mrp = Number(
                      variantData?.mrp || val?.Product_Variant?.mrp || 0,
                    );

                    const price = Number(
                      variantData?.price || val?.Product_Variant?.price || 0,
                    );

                    const finalmrp = Number(mrp).toFixed(2);
                    const finalprice = Number(price).toFixed(2);

                    return (
                      <tr key={val.id ?? `${val.product_id}-${val.variant_id}`}>
                        <td>
                          <div className="row">
                            <div
                              className="col-md-4 col-12"
                              onClick={() =>
                                navigate(
                                  `/product-details/${encodeURIComponent(
                                    val?.Product?.id,
                                  )}`,
                                )
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <div className="img_holder">
                                <img
                                  className="Product_img"
                                  src={
                                    val?.Product?.image ||
                                    variantData?.image ||
                                    val?.Product_Variant?.image
                                  }
                                  alt={val?.Product?.name || "Product image"}
                                />
                              </div>
                            </div>
                            <div className="col-md-8 col-12">
                              <div className="info_text_holder">
                                <div>
                                  <h4>{val?.Product?.name}</h4>

                                  {offerDetails[data.data.indexOf(val)]
                                    ?.type === "buy_one_get_one" && (
                                    <div className="cart_offer_badge">
                                      {offerDetails[data.data.indexOf(val)]
                                        ?.freeQuantity > 0 ? (
                                        <span>
                                          🎁{" "}
                                          {
                                            offerDetails[data.data.indexOf(val)]
                                              ?.freeQuantity
                                          }{" "}
                                          {offerDetails[data.data.indexOf(val)]
                                            ?.freeQuantity === 1
                                            ? "Item"
                                            : "Items"}{" "}
                                          FREE
                                        </span>
                                      ) : (
                                        offerDetails[data.data.indexOf(val)]
                                          ?.oddDiscountPercentage > 0 && (
                                          <span>
                                            {Number(
                                              offerDetails[
                                                data.data.indexOf(val)
                                              ]?.oddDiscountPercentage || 0,
                                            )}{" "}
                                            % OFF
                                          </span>
                                        )
                                      )}

                                      <small>
                                        {" "}
                                        • Saved {symbol}{" "}
                                        {Number(
                                          offerDetails[data.data.indexOf(val)]
                                            ?.totalDiscount || 0,
                                        ).toFixed(2)}
                                      </small>
                                    </div>
                                  )}

                                  {offerDetails[data.data.indexOf(val)]
                                    ?.type === "normal_discount" && (
                                    <div className="cart_offer_badge">
                                      <span>
                                        {
                                          offerDetails[data.data.indexOf(val)]
                                            ?.discountType
                                        }{" "}
                                        (
                                        {Number.isInteger(
                                          Number(
                                            offerDetails[data.data.indexOf(val)]
                                              ?.percentage || 0,
                                          ),
                                        )
                                          ? Number(
                                              offerDetails[
                                                data.data.indexOf(val)
                                              ]?.percentage || 0,
                                            )
                                          : Number(
                                              offerDetails[
                                                data.data.indexOf(val)
                                              ]?.percentage || 0,
                                            ).toFixed(2)}
                                        %)
                                      </span>

                                      <small>
                                        {" "}
                                        • Saved {symbol}{" "}
                                        {Number(
                                          offerDetails[data.data.indexOf(val)]
                                            ?.amount || 0,
                                        ).toFixed(2)}
                                      </small>
                                    </div>
                                  )}
                                  <p className="mb-1">
                                    {val?.Product_Variant?.name &&
                                      `Polish : ${val?.Product_Variant?.name}`}
                                  </p>

                                  <p className="mb-1">
                                    {val?.Double_Variant?.name &&
                                      `Colour : ${val?.Double_Variant?.name}`}
                                  </p>

                                  <p className="mb-1">
                                    {val?.Triple_Variant?.name &&
                                      `Size : ${val?.Triple_Variant?.name}`}
                                  </p>
                                  <p className="price_text">
                                    {/* <span>
                                        {symbol} {mrp.toFixed(2)}
                                      </span> */}
                                    {symbol} {price.toFixed(2)}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>

                        <td>
                          <div className="d-flex flex-column align-items-center">
                            <div className="Quantity_tr_holder justify-content-center">
                              <Increment_decrement_btn_holder_add
                                val={val}
                                quantity={val.quantity}
                                setInstock={setInstock}
                                isOutOfStock={disableIncrease}
                                openDeleteModal={openDeleteModal}
                              />

                              <FontAwesomeIcon
                                className="trash_icon"
                                icon={faTrashCan}
                                // onClick={() => {
                                //   deleteCart(
                                //     val?.id,
                                //     val?.product_id,
                                //     val?.variant_id ||
                                //       val?.d_variant_id ||
                                //       val?.t_variant_id,
                                //   );
                                // }}
                                onClick={() =>
                                  openDeleteModal(
                                    val?.id,
                                    val?.product_id,
                                    val?.variant_id ||
                                      val?.d_variant_id ||
                                      val?.t_variant_id,
                                  )
                                }
                              />
                            </div>

                            {disableIncrease && (
                              <p className="text-danger fw-bold mt-1 mb-0">
                                {currentStock <= 0
                                  ? "Out of stock"
                                  : `Only ${currentStock} available`}
                              </p>
                            )}
                          </div>
                        </td>

                        <td>
                          <div className="price_holder">
                            {/* <p className="price_text">
                              <span>
                                  {symbol}{" "}
                                  {Number(
                                    finalmrp * Number(val.quantity),
                                  ).toFixed(2)}
                                </span>
                              {symbol}{" "}
                              {Number(
                                finalprice * Number(val.quantity),
                              ).toFixed(2)}{" "}
                            </p> */}

                            {(() => {
                              const itemIndex = data.data.indexOf(val);
                              const itemOffer = offerDetails[itemIndex];

                              const totalAmount =
                                Number(price || 0) * Number(val?.quantity || 0);

                              const discountAmount = Number(
                                itemOffer?.totalDiscount || 0,
                              );

                              const payableAmount = Math.max(
                                0,
                                totalAmount - discountAmount,
                              );

                              return (
                                <div className="price_holder">
                                  {discountAmount > 0 ? (
                                    <>
                                      <p
                                        className="price_text text-muted"
                                        style={{
                                          textDecoration: "line-through",
                                          marginBottom: "2px",
                                          fontWeight: "400",
                                        }}
                                      >
                                        {symbol} {totalAmount.toFixed(2)}
                                      </p>

                                      <p
                                        className="price_text"
                                        style={{
                                          marginBottom: "0",
                                          marginLeft: "10px",
                                        }}
                                      >
                                        {"   "}
                                        {symbol}
                                        {payableAmount.toFixed(2)}
                                      </p>
                                    </>
                                  ) : (
                                    <p className="price_text">
                                      {symbol} {totalAmount.toFixed(2)}
                                    </p>
                                  )}
                                </div>
                              );
                            })()}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>

          <div className="mobile_view_table_holder">
            {data?.data?.map((val, index) => {
              const variantData = getVariantData(val);

              const currentStock = getStock(val);

              const disableIncrease = Number(val?.quantity) >= currentStock;
              //  get mrp & price for each item
              const mrp = Number(
                variantData?.mrp || val?.Product_Variant?.mrp || 0,
              );

              const price = Number(
                variantData?.price || val?.Product_Variant?.price || 0,
              );

              // convert with currency rate
              const totalMrp = mrp * Number(val?.quantity || 1);
              const totalPrice = price * Number(val?.quantity || 1);

              return (
                <div className="mobile_product_card" key={index}>
                  <div className="row">
                    <div className="col-5">
                      <div
                        className="img_holder"
                        onClick={() =>
                          navigate(
                            `/product-details/${encodeURIComponent(
                              val?.Product?.id,
                            )}`,
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={
                            val?.Product?.image ||
                            variantData?.image ||
                            val?.Product_Variant?.image
                          }
                          alt={val?.Product?.name || "Product image"}
                          className="prod_img"
                        />
                      </div>
                    </div>

                    <div className="col-7">
                      <div className="descn_holder">
                        <p className="product_name">{val?.Product?.name}</p>

                        {offerDetails[data.data.indexOf(val)]?.type ===
                          "buy_one_get_one" && (
                          <div className="cart_offer_badge">
                            {offerDetails[data.data.indexOf(val)]
                              ?.freeQuantity > 0 ? (
                              <span>
                                🎁{" "}
                                {
                                  offerDetails[data.data.indexOf(val)]
                                    ?.freeQuantity
                                }{" "}
                                {offerDetails[data.data.indexOf(val)]
                                  ?.freeQuantity === 1
                                  ? "Item"
                                  : "Items"}{" "}
                                FREE
                              </span>
                            ) : (
                              offerDetails[data.data.indexOf(val)]
                                ?.oddDiscountPercentage > 0 && (
                                <span>
                                  {Number(
                                    offerDetails[data.data.indexOf(val)]
                                      ?.oddDiscountPercentage || 0,
                                  )}{" "}
                                  % OFF
                                </span>
                              )
                            )}

                            <small>
                              {" "}
                              • Saved {symbol}{" "}
                              {Number(
                                offerDetails[data.data.indexOf(val)]
                                  ?.totalDiscount || 0,
                              ).toFixed(2)}
                            </small>
                          </div>
                        )}

                        {offerDetails[data.data.indexOf(val)]?.type ===
                          "normal_discount" && (
                          <div className="cart_offer_badge">
                            <span>
                              {
                                offerDetails[data.data.indexOf(val)]
                                  ?.discountType
                              }{" "}
                              (
                              {Number.isInteger(
                                Number(
                                  offerDetails[data.data.indexOf(val)]
                                    ?.percentage || 0,
                                ),
                              )
                                ? Number(
                                    offerDetails[data.data.indexOf(val)]
                                      ?.percentage || 0,
                                  )
                                : Number(
                                    offerDetails[data.data.indexOf(val)]
                                      ?.percentage || 0,
                                  ).toFixed(2)}
                              %)
                            </span>

                            <small>
                              {" "}
                              • Saved {symbol}{" "}
                              {Number(
                                offerDetails[data.data.indexOf(val)]?.amount ||
                                  0,
                              ).toFixed(2)}
                            </small>
                          </div>
                        )}

                        <p className="mb-1">
                          {val?.Product_Variant?.name &&
                            `Polish : ${val?.Product_Variant?.name}`}
                        </p>

                        <p className="mb-1">
                          {val?.Double_Variant?.name &&
                            `Colour : ${val?.Double_Variant?.name}`}
                        </p>

                        <p className="mb-1">
                          {val?.Triple_Variant?.name &&
                            `Size : ${val?.Triple_Variant?.name}`}
                        </p>
                        {/* ✅ price display */}
                        {/* <p className="price_text">
                          {symbol}
                          {totalPrice.toFixed(2)}
                          <span className="mrp_text">
                            {symbol}
                            {totalMrp.toFixed(2)}
                          </span>
                        </p> */}

                        {(() => {
                          const itemOffer = offerDetails[index];

                          const totalAmount =
                            Number(price || 0) * Number(val?.quantity || 0);

                          const discountAmount = Number(
                            itemOffer?.totalDiscount || 0,
                          );

                          const payableAmount = Math.max(
                            0,
                            totalAmount - discountAmount,
                          );

                          return (
                            <div className="price_holder">
                              {discountAmount > 0 ? (
                                <>
                                  <p
                                    className="price_text"
                                    style={{
                                      textDecoration: "line-through",
                                      marginBottom: "2px",
                                      fontWeight: "400",
                                    }}
                                  >
                                    {symbol} {totalAmount.toFixed(2)}
                                  </p>

                                  <p
                                    className="price_text"
                                    style={{
                                      marginBottom: "0",
                                      marginLeft: "10px",
                                      fontSize: "15px",
                                    }}
                                  >
                                    {symbol} {payableAmount.toFixed(2)}
                                  </p>
                                </>
                              ) : (
                                <p className="price_text">
                                  {symbol} {totalAmount.toFixed(2)}
                                </p>
                              )}
                            </div>
                          );
                        })()}

                        {/* <p className="weight_text">
                          Metal:
                          <span>
                            {val?.Product_Variant?.Metal?.name ||
                              val?.Double_Variant?.Product_Variant?.Metal
                                ?.name ||
                              val?.Triple_Variant?.Double_Variant
                                ?.Product_Variant?.Metal?.name}
                          </span>
                        </p> */}

                        <div className="all_btns_holder">
                          <div className="d-flex flex-column align-items-start">
                            <div className="Quantity_tr_holder">
                              <Increment_decrement_btn_holder_add
                                val={val}
                                quantity={val?.quantity}
                                isOutOfStock={disableIncrease}
                                openDeleteModal={openDeleteModal}
                              />

                              <FontAwesomeIcon
                                className="trash_icon"
                                icon={faTrashCan}
                                // onClick={() =>
                                //   deleteCart(
                                //     val?.id,
                                //     val?.product_id,
                                //     val?.variant_id ||
                                //       val?.d_variant_id ||
                                //       val?.t_variant_id,
                                //   )
                                // }

                                onClick={() =>
                                  openDeleteModal(
                                    val?.id,
                                    val?.product_id,
                                    val?.variant_id ||
                                      val?.d_variant_id ||
                                      val?.t_variant_id,
                                  )
                                }
                              />
                            </div>

                            {disableIncrease && (
                              <div className="text-danger fw-bold mt-1">
                                {currentStock <= 0
                                  ? "Out of stock"
                                  : `Only ${currentStock} available`}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="ContinueShopping_text">
            <Link to={"/shops"}>
              <p>Continue Shopping</p>
            </Link>
          </div>
        </div>
      </section>

      {/* Delete Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
        className="Cancel_Reason_Modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Remove Product From Cart</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to remove this product from the cart?
        </Modal.Body>

        <Modal.Footer>
          <div className="btns_holder">
            <Green_btn
              btnText={"Cancel"}
              onClick={() => setShowDeleteModal(false)}
            />

            <Orange_Btn btnText={"Delete"} onClick={handleDelete} />
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Cart_Products_card;
